import React from 'react';
import Page from '../Core/Page';
import './BulkEntryHomePage.scss';
import { BulkEntryNav } from 'Components/Pages/Core/BulkEntryNav';

/**
 * A basic landing page that shows links to all bulk entry pages
 * when a specific page wasn't requested
 */
const BulkEntryHomePage: React.FC = () => {
  return (
    <Page>
      <div className="BulkEntryHomePage-Page">
        <BulkEntryNav />
      </div>
    </Page>
  );
};

export default BulkEntryHomePage;
